import classNames from 'classnames';
import PropTypes from 'prop-types';

import CTAButton from '../../../CTAButton';

const ProductListBanner = ({ heading, copy, image, linkUrl, linkText, headingImage, layoutLg, destination }) => (
  <div className={classNames('listBanner', layoutLg === true && 'layoutLg')}>
    <div className="bannerContent">
      {headingImage && <img src={headingImage} className="headingImage" />}

      {heading && <h2 className="h3">{heading}</h2>}

      <p>{copy}</p>

      <CTAButton
        href={linkUrl}
        text={linkText}
        type="primary"
        chevron="right"
        color="red"
        data-track="learn-more"
        data-track-element-location="banner CTA"
        data-track-destination={destination}
      />
    </div>
    <div className="imageContainer">{image ? <img src={image} className="bannerImage" /> : ''}</div>
  </div>
);

ProductListBanner.propTypes = {
  heading: PropTypes.string,
  copy: PropTypes.string,
  image: PropTypes.string,
  linkUrl: PropTypes.string,
  linkText: PropTypes.string,
  imageHeading: PropTypes.string,
  layoutLg: PropTypes.bool,
};

export default ProductListBanner;
